<!-- Atbildes sagatavotājs -->
<div class="response-preparer">
  <div class="heading-wrapper">
    <div class="d-flex heading-wrapper_title">
      <h5 class="m-0">
        {{ 'pages.viewInfoRequest.tasks.responsePreparer.title' | translate }}
      </h5>
      <app-tooltip text="irResponsePreparer" />
    </div>
    @if (canEditCoResponsible) {
      <button class="secondary" [disabled]="isCoResponsibleLoading" (click)="openAddArchiveModal()">
        <i class="bi bi-plus-circle"></i>
        {{ 'pages.viewInfoRequest.tasks.responsePreparer.addArchive' | translate }}
      </button>
    }
  </div>

  <div class="preparer-list">
    <!-- Responsible unit row -->
    <div class="preparer-row responsible-row">
      <div class="unit-info">
        <span class="unit-name bold">{{ informationRequest.responsibleStructuralUnitName || '-' }}</span>
        <span class="separator">&#8226;</span>
        <span class="unit-label">{{ 'pages.viewInfoRequest.tasks.responsePreparer.responsibleUnit' | translate }}</span>
        <span class="separator">&#8226;</span>
        <span class="responsible-person">{{ 'pages.viewInfoRequest.tasks.responsePreparer.responsiblePerson' | translate }} ({{ informationRequest.responsibleUserName || '-' }})</span>
      </div>
    </div>

    <!-- Co-responsible unit rows -->
    @for (unit of informationRequest.coResponsibleStructuralUnits; track unit.structuralUnitId) {
      <div class="preparer-row">
        <span class="unit-name">{{ unit.name }}</span>
        @if (canEditCoResponsible) {
          <button class="delete-btn" [disabled]="isCoResponsibleLoading" (click)="removeCoResponsible(unit.structuralUnitId)">
            <i class="bi bi-trash3"></i>
            {{ 'pages.viewInfoRequest.tasks.responsePreparer.delete' | translate }}
          </button>
        }
      </div>
    }
  </div>
</div>

<!-- Uzdevumi -->
<div class="client-notes">
  <div class="heading-wrapper">
    <div class="d-flex heading-wrapper_title">
      <h5 class="m-0">
        {{ 'pages.viewInfoRequest.tasks.title' | translate }}
      </h5>
      <app-tooltip text="irTasks" />
    </div>
    @if (!isTaskCreationDisabled) {
      <button class="secondary" (click)="openCreateModal()">
        <i class="bi bi-plus-circle"></i>
        {{ 'pages.viewInfoRequest.tasks.addTask' | translate }}
      </button>
    }
  </div>

  @if (!tasks.length) {
    <p class="no-notes">
      {{ 'pages.viewInfoRequest.tasks.noTasks' | translate }}
    </p>
  } @else {
    <div class="table_wrapper">
      <table class="table my-0">
        <thead>
          <tr>
            <td class="col-order">{{ 'pages.viewInfoRequest.tasks.columns.order' | translate }}</td>
            <td class="col-status">{{ 'pages.viewInfoRequest.tasks.columns.status' | translate }}</td>
            <td>{{ 'pages.viewInfoRequest.tasks.columns.statusDate' | translate }}</td>
            <td>{{ 'pages.viewInfoRequest.tasks.columns.code' | translate }}</td>
            <td>{{ 'pages.viewInfoRequest.tasks.columns.taskType' | translate }}</td>
            <td>{{ 'pages.viewInfoRequest.tasks.columns.text' | translate }}</td>
            <td>{{ 'pages.viewInfoRequest.tasks.columns.executionDate' | translate }}</td>
            <td>{{ 'pages.viewInfoRequest.tasks.columns.assignee' | translate }}</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          @for (task of tasks; track task.id) {
            <tr [ngClass]="{ 'row-disabled': task.status === 'Completed' || task.status === 'Cancelled', 'row-overdue': isOverdue(task), 'row-approaching': isApproaching(task) }">
              <td class="col-order">{{ task.executionOrder }}.</td>
              <td class="col-status">
                <span class="status-badge" [ngClass]="getStatusClass(task.status)">
                  {{ getStatusLabel(task.status) }}
                </span>
              </td>
              <td>{{ formatDatetime(task.statusChangedOn) }}</td>
              <td>{{ task.code }}</td>
              <td>{{ task.taskTypeName }}</td>
              <td class="text">{{ task.text }}</td>
              <td [ngClass]="{ 'overdue': isOverdue(task), 'approaching': isApproaching(task) }">
                {{ formatDate(task.executionDate) }}
                @if (isOverdue(task) || isApproaching(task)) {
                  <i class="bi bi-exclamation-triangle-fill" [ngClass]="{ 'overdue-icon': isOverdue(task), 'approaching-icon': isApproaching(task) }"></i>
                }
              </td>
              <td>{{ getAssigneeDisplay(task) }}</td>
              <td>
                <div class="action-btn_wrapper">
                  @if (task.status === 'Assigned' || (task.status === 'Accepted' && !task.assigneeUserFullName)) {
                    <button class="action-btn" [disabled]="actionLoadingTaskId === task.id" (click)="acceptTask(task)">
                      {{ 'pages.viewInfoRequest.tasks.actions.accept' | translate }}
                    </button>
                    <button class="action-btn link" [disabled]="actionLoadingTaskId === task.id" (click)="cancelTask(task)">
                      {{ 'pages.viewInfoRequest.tasks.actions.cancel' | translate }}
                    </button>
                  } @else if (task.status === 'Accepted' && task.assigneeUserFullName) {
                    <button class="action-btn" [disabled]="actionLoadingTaskId === task.id" (click)="completeTask(task)">
                      {{ 'pages.viewInfoRequest.tasks.actions.complete' | translate }}
                    </button>
                    <button class="action-btn link" [disabled]="actionLoadingTaskId === task.id" (click)="cancelTask(task)">
                      {{ 'pages.viewInfoRequest.tasks.actions.cancel' | translate }}
                    </button>
                  } @else if (task.status === 'Waiting') {
                    <button class="action-btn link" [disabled]="actionLoadingTaskId === task.id" (click)="cancelTask(task)">
                      {{ 'pages.viewInfoRequest.tasks.actions.cancel' | translate }}
                    </button>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

<app-confirm-modal
  [isOpen]="isCompleteConfirmOpen"
  title="completeTaskConfirmTitle"
  bodyText="completeTaskConfirmBody"
  confirmText="completeTaskConfirm"
  denyText="completeTaskDeny"
  (confirm)="confirmCompleteTask()"
  (cancel)="cancelCompleteTask()" />

<app-confirm-modal
  [isOpen]="isCancelConfirmOpen"
  title="cancelTaskConfirmTitle"
  bodyText="cancelTaskConfirmBody"
  confirmText="cancelTaskConfirm"
  denyText="cancelTaskDeny"
  (confirm)="confirmCancelTask()"
  (cancel)="cancelCancelTask()" />

<app-ir-create-task-modal
  [isOpen]="isCreateModalOpen"
  [informationRequest]="informationRequest"
  [minExecutionOrder]="minExecutionOrder"
  [isFirstTask]="tasks.length === 0"
  (cancel)="isCreateModalOpen = false"
  (taskCreated)="onTaskCreated($event)" />

<app-confirm-modal
  [isOpen]="isDeleteCoResponsibleConfirmOpen"
  title="deleteCoResponsibleConfirmTitle"
  bodyText="deleteCoResponsibleConfirmBody"
  confirmText="deleteCoResponsibleConfirm"
  denyText="deleteCoResponsibleDeny"
  (confirm)="confirmRemoveCoResponsible()"
  (cancel)="cancelRemoveCoResponsible()" />

<app-ir-add-co-responsible-modal
  [isOpen]="isAddArchiveModalOpen"
  [isConsolidated]="informationRequest.isConsolidated"
  [availableUnits]="availableStructuralUnits"
  [coResponsibleCount]="informationRequest.coResponsibleStructuralUnits.length"
  [isLoading]="isCoResponsibleLoading"
  (confirmed)="onAddArchiveConfirmed($event)"
  (closed)="onAddArchiveClosed()" />
